import { Injectable, signal, WritableSignal } from '@angular/core';
import { Profile } from '@projects/adir/src/interfaces/profile.interface';

@Injectable({ providedIn: 'root' })
export class AppStore {
  readonly state: {
    profile: {
      [K in keyof Profile.Response]: WritableSignal<Profile.Response[K]>;
    };
  } = {
    profile: {
      imageURL: signal(''),
      displayName: signal(''),
    },
  };
}
